import axios from 'axios';

let axiosInstance = null;
let contentAxiosInstance = null;
const CancelToken = axios.CancelToken;
export default async ({ store }) => {
  axiosInstance = axios.create();

  const response = await axios.get('statics/config.json', {
    headers: { 'Cache-control': 'no-cache' },
  });

  store.commit('config/setConfig', response.data);

  const config = store.getters['config/config'];

  axiosInstance = axios.create({
    baseURL: `${config.API.BASE_URL}/api/`,
    headers: {
      'Client-Version': config.APP.RELEASE_TAG,
    },
  });

  contentAxiosInstance = axios.create({
    baseURL: config.API.CONTENT_BASE_URL,
  });

  contentAxiosInstance.interceptors.request.use((con) => {
    con.params = {
      cacheRefreshParam: config.CACHCONTROLGUID,
    };

    return con;
  });
};

export { axiosInstance, contentAxiosInstance, CancelToken };
